export const role = {
  roleGroup: [{
    value: 1, label: '管理员'
  }, {
    value: 2, label: '总经理'
  }, {
    value: 3, label: '业务经理'
  }, {
    value: 4, label: '业管专员'
  }, {
    value: 5, label: '上游政策专员'
  }, {
    value: 6, label: '下游政策专员'
  }, {
    value: 7, label: '财务经理'
  }, {
    value: 8, label: '上游结算专员'
  }, {
    value: 9, label: '下游结算专员'
  }, {
    value: 10, label: ' 出纳'
  }, {
    value: 11, label: ' 单证'
  }, {
    value: 12, label: ' 团队长'
  }, {
    value: 13, label: ' 机构负责人'
  }, {
    value: 14, label: ' 出单内勤'
  }, {
    value: 15, label: ' 业务员'
  }, {
    value: 16, label: ' 收款人'
  }],
  systemVersion: [{
    value: 1, label: '标准版A'
  }, {
    value: 2, label: '标准版B'
  }, {
    value: 7, label: '标准版C'
  }, {
    value: 3, label: '专业版'
  }, {
    value: 4, label: '企业版'
  }, {
    value: 5, label: '旗舰版'
  }, {
    value: 6, label: '门店版'
  }, {
    value: 24, label: '集团版'
  }],
  systemVersionList: [{
    value: 1, label: '标准版A'
  }, {
    value: 2, label: '标准版B'
  }, {
    value: 7, label: '标准版C'
  }, {
    value: 3, label: '专业版'
  }, {
    value: 4, label: '企业版'
  }, {
    value: 5, label: '旗舰版'
  }, {
    value: 6, label: '门店版'
  }, {
    value: 21, label: '车商版'
  }, {
    value: 22, label: '标准版'
  }, {
    value: 23, label: '入门版'
  }, {
    value: 24, label: '集团版'
  }],
  systemVersionFiveList: [{
    value: 1, label: 'V5试用版'
  }, {
    value: 3, label: 'V5入门版'
  }, {
    value: 4, label: 'V5标准版'
  }, {
    value: 5, label: 'V5专业版'
  }, {
    value: 6, label: 'V5旗舰版'
  }],
  roleGroupType: [{
    value: -1, label: '全部角色'
  }, {
    value: 1, label: '业管角色'
  }, {
    value: 2, label: '财管角色'
  }, {
    value: 3, label: '人管角色'
  }, {
    value: 4, label: '综合角色'
  }],
  sysType: [{
    value: 1, label: '车险'
  }, {
    value: 2, label: '非车'
  }, {
    // value: 3, label: '人管角色'}, {
    value: 4, label: '寿险'
  }, {
    value: 5, label: '人管'
  }, {
    value: 6, label: '设置'
  }, {
    value: 7, label: '财务'
  }, {
    value: 8, label: '分支'
  }, {
    value: 9, label: '出单'
  }]
}

export default {
  role
}



// WEBPACK FOOTER //
// ./src/data/role.js